import { TableTemplate } from 'types/tableTemplate';

export const resourcesTableTemplate: TableTemplate[] = [
  { id: 'id', description: 'ID', originalId: 'id', width: 100 },
  { id: 'name', description: 'NOME', originalId: 'name', width: 300 },
  { id: 'title', description: 'TÍTULO', originalId: 'title', width: 300 },
  { id: 'description', description: 'DESCRIÇÃO', originalId: 'description', width: 400 },
];
